import React from 'react';
import { useParams } from 'react-router-dom';
import ItemBrowser from '../components/Items/ItemBrowser';
import ItemDetail from '../components/Items/ItemDetail';

export default function ItemsPage() {
  const { classname } = useParams();

  if (classname) {
    return <ItemDetail />;
  }

  return <ItemBrowser />;
}
